const inputErrors = {
  props: {
    error: {
      type: Boolean,
      default: false,
    },
    success: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: [String, Array],
      default: '',
    },
    inputInfo: {
      type: String,
      default: '',
    },
  },
  computed: {
    errorMessageText() {
      if (Array.isArray(this.errorMessage)) {
        return this.errorMessage.join(', ');
      }
      return this.errorMessage;
    },
  },
};

export default inputErrors;
